import * as React from "react";
import { observer, inject } from "mobx-react";
import { IHandoversStore } from "../Stores/HandoversStore";
import { INotificationsStore } from "../Stores/NotificationsStore";
import WsAccessor from "./WsAccessor";
import { Toast } from "../Tools/Toast";
import _ from "lodash";
import { ISharedValuesStore } from "../Stores/SharedValuesStore";

interface IProps {
  notifications?: INotificationsStore;
  handovers?: IHandoversStore;
  sharedValues?: ISharedValuesStore;
}

@inject("notifications", "handovers", "sharedValues")
@observer
export default class WsHandlers extends React.Component<IProps> {
  handlers: { messageType: string; handler: (e: CustomEvent) => void }[];
  accessor = new WsAccessor();
  toast: Toast = new Toast();

  constructor(props: IProps) {
    super(props);

    this.handlers = [
      { messageType: "Notifications", handler: this.notificationsEventHandler },
      { messageType: "Notification", handler: this.notificationEventHandler },
      { messageType: "NotificationRead", handler: this.notificationReadEventHandler },
      { messageType: "AllNotificationsRead", handler: this.allNotificationsReadEventHandler },
      { messageType: "AwaitingHandover", handler: this.awaitingHandoverEventHandler },
      { messageType: "HandoverProcessed", handler: this.handoverProcessedEventHandler },
      { messageType: "Toast", handler: this.toastEventHandler },
      { messageType: "TokenNoLongerRelevant", handler: this.tokenNoLongerRelevantEventHandler },
      { messageType: "SessionInvalid", handler: this.sessionInvalidEventHandler },
    ];
  }

  subscribeAll = () => {
    _.forEach(this.handlers, (pair) => {
      this.accessor.subscribe(pair.messageType, pair.handler);
    });
  };

  unsubscribeAll = () => {
    _.forEach(this.handlers, (pair) => {
      this.accessor.unsubscribe(pair.messageType, pair.handler);
    });
  };

  notificationsEventHandler = (e: CustomEvent) => {
    this.props.notifications.appendNotifications(e.detail.notifications);
  };

  notificationEventHandler = (e: CustomEvent) => {
    this.props.notifications.appendNotification(e.detail.notification);
  };

  notificationReadEventHandler = (e: CustomEvent) => {
    this.props.notifications.removeRead(e.detail.notificationId);
  };

  allNotificationsReadEventHandler = () => {
    this.props.notifications.handleAllAsRead();
  };

  handleHandover() {
    return this.accessor.configuration().handovers && this.accessor.configuration().handovers.handoversHandling;
  }

  awaitingHandoverEventHandler = (e: CustomEvent) => {
    if (this.handleHandover()) {
      this.props.handovers.setAwaitingHandover(e.detail.handover);
    }
  };

  handoverProcessedEventHandler = (e: CustomEvent) => {
    if (this.handleHandover()) {
      this.props.handovers.handoverProcessed(e.detail.handoverId);
    }
  };

  toastEventHandler = (e: CustomEvent) => {
    this.toast.show(e.detail.message, e.detail.type);
  };

  tokenNoLongerRelevantEventHandler = async (e: CustomEvent) => {
    await this.props.sharedValues.triggerTokenRefresh();
    var event = new Event("requestPageReload");
    window.dispatchEvent(event);
  };

  sessionInvalidEventHandler = (e: CustomEvent) => {
    this.props.sharedValues.isSessionValid = false;
  };

  render() {
    return <></>;
  }
}
